"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_router_flux_1 = require("react-native-router-flux");

var tabs_1 = require("../../../../components/pricing/tabs/tabs/tabs");

var pricing_experience_navigator_screen_names_1 = require("../../../../experiences/pharmacy-pricing-experience/pricing-experience-navigator/pricing-experience-navigator.screen-names");

var constants_1 = require("../../../../theming/pricing-system/constants");

var tabItems = [{
  text: constants_1.AdminTabsContent.priceLookupTabText,
  value: pricing_experience_navigator_screen_names_1.NavigationScreenNames.priceLookupPage
}, {
  text: constants_1.AdminTabsContent.pharmacyManagementTabText,
  value: pricing_experience_navigator_screen_names_1.NavigationScreenNames.pharmacyManagementPage
}];
var rulesTab = {
  text: 'Pricing Rules',
  value: pricing_experience_navigator_screen_names_1.NavigationScreenNames.pharmacyPricingScreen
};

var AdminTabs = function (_super) {
  __extends(AdminTabs, _super);

  function AdminTabs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onTabSelect = function (tab) {
      react_native_router_flux_1.Actions[tab.value].call(_this);
    };

    return _this;
  }

  AdminTabs.prototype.render = function () {
    var items = tabItems.slice();

    if (this.props.showRulesTab) {
      items.push(rulesTab);
    }

    return react_1.default.createElement(tabs_1.Tabs, {
      tabItems: items,
      onTabSelect: this.onTabSelect,
      selectedTabValue: this.props.selectedTabValue
    });
  };

  return AdminTabs;
}(react_1.default.Component);

exports.AdminTabs = AdminTabs;